import { z } from 'zod';
const getErrorItem = (code, errorMapper) => ({ [code]: errorMapper });
export const setZodErrorMap = ({ errorMessages, defaultErrorMessage, }) => {
    const errorMapperMap = {
        ...getErrorItem('invalid_type', (issue) => {
            if (issue.input === 'undefined') {
                return errorMessages.required;
            }
            return undefined;
        }),
    };
    z.config({
        customError: (issue) => {
            const errorMapper = errorMapperMap[issue.code];
            if (!errorMapper)
                return defaultErrorMessage;
            if (typeof errorMapper === 'string')
                return errorMapper;
            const message = errorMapper(issue) ?? defaultErrorMessage;
            return message;
        },
    });
};
